import {delay} from '../../utils'

let _statusCode = 200;

/**
 * get & set response status_code
 * 
 * @param {number} code status code
 * @return {number} current status code
 */
export function statusCode(code) {
  if (code) {
    _statusCode = code;
  }
  return _statusCode;
}

/**
 * generate response for mock
 * 
 * @param {object} options {delay: in ms, action: response data generator}
 * @return {Array} response array ready for axios mock
 */
export async function response({delay: ms, action}) {
  if (ms) {
    await delay(ms);
  }
  
  let status, response_data;
  _statusCode = 200;
  
  try {
    response_data = action();
    status = _statusCode;

  } catch (error) {
    if (error instanceof ResponseError) {
      // eslint-disable-next-line
      console.warn(error, {...error});

      response_data = {errors: error.errors};
      status = error.statusCode;
    } else {
      // eslint-disable-next-line
      console.error(error);
      
      status = 500;
    }
  }

  return [status, response_data];
}

/**
 * throwing this error in controller methods will stop and return response passed with the error (like laravel)
 */
export class ResponseError extends Error {
  constructor(statusCode = 500, errors, message = 'Thrown in api mock', ...args) {
    super(message, ...args);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ResponseError);
    }

    this.name = 'ResponseError';

    // respone data
    this.statusCode = statusCode;
    this.errors = errors;
  }
}